module.exports = __webpack_public_path__ + "img/g_q3.6935903c.jpeg";